import type EquipmentAvailable from '@/assets/ts/types/EquipmentAvailable'
import type MeasurementUnits from '@/assets/ts/types/MeasurementUnits'
import type WeightUnits from '@/assets/ts/types/WeightUnits'

interface ProfileStore {
  currentProgram: {
    /**
     * The start date of the current program.
     */
    startDate: string;
  };
  equipmentAvailable?: EquipmentAvailable | undefined;
  /**
   * The member ID.
   */
  ID: number;
  totalSessionsCompleted: number;
  rir: boolean;
  /**
   * Whether or not the user has RPE enabled.
   */
  rpe: boolean;
  settings: {
    units: {
      /**
       * The units used for body measurements.
       */
      measurements: MeasurementUnits;
      /**
       * The units used for training.
       */
      training: WeightUnits;
      /**
       * The units used for weight in progress.
       */
      weight: WeightUnits;
    };
    equipmentAvailable?: EquipmentAvailable;
    /**
     * Whether unilateral tracking is enabled by default for unilateral exercises.
     * When true, sets with unilateral exercises will show L/R side inputs.
     * Last-used value becomes the global default.
     */
    unilateralTrackingEnabled?: boolean;
  };
}

const useStoreProfile = defineStore( 'profileStore', () => {
  const profile = useStorage<ProfileStore>( 'profile', {
    currentProgram: {
      startDate: '',
    },
    equipmentAvailable: undefined,
    ID: 0,
    totalSessionsCompleted: 0,
    rir: true,
    rpe: true,
    settings: {
      units: {
        measurements: 'inches',
        training: 'pounds',
        weight: 'pounds',
      },
      unilateralTrackingEnabled: true, // Default to enabled
    }
  } )

  /**
   * Get the total number of sessions for a member.
   *
   * @param memberId The member ID.
   */
  const getTotalSessions = async( memberId: number ) =>
    Http.get( `/member/${memberId}/total-sessions` )

  return {
    profile,
    getTotalSessions
  }
} )

export default useStoreProfile